import Flickity from 'flickity';

class Carousel {
  constructor() {
    this.flkty = '';
    this.elem = document.querySelectorAll('.carousel');
    this.initialize();
  }

  initialize() {
    for (let i = 0; i < this.elem.length; i++) {
      this.flkty = new Flickity(this.elem[i], {
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        percentPosition: false,
        wrapAround: true,
        groupCells: true,
        pageDots: true,
        prevNextButtons: true,
        freeScroll: false,
      });
    }
  }
}

export default Carousel;
